

import React, { useState } from "react";

function FormatDecimal(props)
{

    
    var n = props.value

    n = parseFloat(n).toFixed(2);

    if(isNaN(n)) n = "0";

    var str = "" + n;
    str = str.replace('.', ',')
    
    
    const toClipboard = (wartosc) => {

        navigator.clipboard.writeText(wartosc)
        .then(() => {
            console.log("Skopiowano!");

            if(props.mainView != undefined) {
                props.mainView.toast("Skopiowano do schowka!");
            }

        })
        .catch(err => {
            console.error("Błąd kopiowania: ", err);
        });

    }


    return <React.Fragment>
        {str} 
        {
            props.copy != undefined && props.copy == '1' &&
            <sup className="link_color" onClick={ ()=>{ toClipboard(str); }   } >&nbsp;(kopiuj)</sup>
        }
    </React.Fragment>
}

export default FormatDecimal;